
export const CUSTOM_ROUTE_MOBILE_MAP = {
  planner: 'planner',
  map: 'map',
  chatbot: 'chatbot',
  more: 'more',
} as const;